import { render, staticRenderFns } from "./RewardsSection.vue?vue&type=template&id=0a8cf0be"
import script from "./RewardsSection.vue?vue&type=script&lang=js"
export * from "./RewardsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports